/* Emèlle theme — vanilla JS: drawer, search, reveal, gallery, product form (Ajax cart), cart page, toast. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const EM = window.EM || { cart: '/cart', add: '/cart/add', change: '/cart/change', update: '/cart/update', t: {} };
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* drawer + search. motion.js may provide EM.motion.drawerOpen/drawerClose (promises); without them the CSS keyframe plays. */
  const drawer = $('#drawer'), search = $('#search');
  const panel = drawer && $('.drawer__panel', drawer), scrim = drawer && $('.drawer__scrim', drawer);
  const drawerLinks = () => drawer ? $$('.drawer__special, .drawer__cta, .drawer__link, .drawer__foot a', drawer) : [];
  let drawerBusy = false;
  const openDrawer = async o => {
    if (!drawer || drawerBusy || drawer.hidden === !o) return;
    const m = EM.motion || {};
    drawerBusy = true;
    $$('[data-drawer-open]').forEach(b => b.setAttribute('aria-expanded', o));
    document.body.style.overflow = o ? 'hidden' : '';
    try {
      if (o) { drawer.hidden = false; if (m.drawerOpen) await m.drawerOpen(panel, scrim, drawerLinks()); $('.drawer__link', drawer)?.focus(); }
      else { if (m.drawerClose) await m.drawerClose(panel, scrim, drawerLinks()); drawer.hidden = true; }
    } finally { drawerBusy = false; }
  };
  EM.drawer = { open: () => openDrawer(true), close: () => openDrawer(false) };
  $$('[data-drawer-open]').forEach(b => b.addEventListener('click', () => openDrawer(true)));
  $$('[data-drawer-close]').forEach(b => b.addEventListener('click', () => openDrawer(false)));
  $$('[data-search-open]').forEach(b => b.addEventListener('click', () => { if (!search) return; search.hidden = false; $('input', search)?.focus(); }));
  $$('[data-search-close]').forEach(b => b.addEventListener('click', () => { if (search) search.hidden = true; }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { openDrawer(false); if (search) search.hidden = true; } });

  /* header: compact after 80 px of scroll. It never hides: the logo must stay reachable. */
  const hd = $('.hd');
  if (hd) {
    let queued = false, compact = false;
    const sync = () => { if (scrollY > 100) compact = true; else if (scrollY < 20) compact = false; hd.classList.toggle('is-compact', compact); queued = false; };
    addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(sync); } }, { passive: true });
    sync();
  }

  /* colour scheme: CSS follows the browser; "Chiaro" / "Scuro" pin one with data-theme on <html>, kept in localStorage
     (the layout's inline script applies it before paint). The theme-color metas follow the computed ground: seasons and overrides included. */
  const root = document.documentElement, prefersDark = matchMedia('(prefers-color-scheme: dark)');
  const effective = () => root.dataset.theme || (prefersDark.matches ? 'dark' : 'light');
  const scheme = {
    get: () => root.dataset.theme || 'auto',
    set: v => {
      if (v !== 'light' && v !== 'dark') v = 'auto';
      if (v === 'auto') delete root.dataset.theme; else root.dataset.theme = v;
      try { if (v === 'auto') localStorage.removeItem('em-theme'); else localStorage.setItem('em-theme', v); } catch { /* storage blocked: the choice lasts for this page */ }
      $$('[data-scheme-set]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.schemeSet === v)));
      const label = effective() === 'dark' ? EM.t.toLight : EM.t.toDark;
      if (label) $$('[data-scheme-toggle]').forEach(b => b.setAttribute('aria-label', label));
      const ground = getComputedStyle(root).getPropertyValue('--greige').trim();
      if (ground) $$('meta[name="theme-color"]').forEach(m => { m.content = ground; });
    },
  };
  EM.scheme = scheme;
  $$('[data-scheme-set]').forEach(b => b.addEventListener('click', () => scheme.set(b.dataset.schemeSet)));
  $$('[data-scheme-toggle]').forEach(b => b.addEventListener('click', () => scheme.set(effective() === 'dark' ? 'light' : 'dark')));
  prefersDark.addEventListener('change', () => scheme.set(scheme.get()));
  scheme.set(scheme.get());

  /* reveal on scroll (only below the fold, only with motion allowed) */
  if (!reduced && 'IntersectionObserver' in window) {
    const els = $$('.sec:not([data-swarm]) .grid > *, .sec .voices > *, .sec .also > *, .craft__fact, .custom__text, .custom__media, .story__media, .story__text').filter(el => el.getBoundingClientRect().top > innerHeight);
    els.forEach(el => el.classList.add('reveal'));
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach(el => io.observe(el));
  }

  /* gallery */
  const gal = $('[data-gallery]');
  if (gal) {
    /* the photos are one sideways row (each slide as wide as the row): a thumbnail scrolls it to its photo, the thumbnails follow it */
    const track = $('.pdp__main', gal), slides = $$('.pdp__slide', gal), thumbs = $$('.pdp__thumb', gal);
    const go = i => track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    thumbs.forEach((b, i) => b.addEventListener('click', () => go(i)));
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = Math.round(track.scrollLeft / (track.clientWidth || 1)); thumbs.forEach((x, j) => x.classList.toggle('is-on', j === i)); }); }, { passive: true });
    /* the photos after the first load once the page has, so a swipe never lands on an empty frame */
    const rest = () => slides.slice(1).forEach(s => { const img = $('img', s); if (img) img.loading = 'eager'; });
    if (document.readyState === 'complete') rest(); else addEventListener('load', rest, { once: true });
    /* "Vedi la foto con le misure": show that photo and bring the gallery into view */
    $$('[data-show-misure]').forEach(btn => btn.addEventListener('click', () => { const t = $('.pdp__thumb[data-misure]', gal); if (!t) return; t.click(); track.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); }));
  }

  /* photo drop zone: pick or drop one image, see it, change or remove it; the input keeps the file for the add-to-cart FormData */
  $$('[data-drop]').forEach(drop => {
    const input = $('input[type=file]', drop), empty = $('.drop__empty', drop), full = $('.drop__full', drop), img = $('.drop__preview', drop), name = $('.drop__name', drop);
    let url = null;
    const show = () => {
      let f = input.files && input.files[0];
      if (f && f.type && !f.type.startsWith('image/')) { input.value = ''; f = null; }
      if (url) { URL.revokeObjectURL(url); url = null; }
      empty.hidden = !!f; full.hidden = !f; drop.classList.toggle('is-full', !!f);
      if (f) { url = URL.createObjectURL(f); img.hidden = false; img.src = url; name.textContent = f.name; } else { img.removeAttribute('src'); }
    };
    img.addEventListener('error', () => { img.hidden = true; }); // HEIC outside Safari: no preview, the icon stays
    input.addEventListener('change', show);
    ['dragenter', 'dragover'].forEach(t => drop.addEventListener(t, e => { e.preventDefault(); drop.classList.add('is-over'); }));
    ['dragleave', 'dragend', 'drop'].forEach(t => drop.addEventListener(t, () => drop.classList.remove('is-over')));
    drop.addEventListener('drop', e => {
      e.preventDefault();
      const f = [...(e.dataTransfer?.files || [])].find(x => !x.type || x.type.startsWith('image/'));
      if (!f) return;
      const dt = new DataTransfer(); dt.items.add(f); input.files = dt.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    $('[data-drop-remove]', drop)?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); input.value = ''; input.dispatchEvent(new Event('change', { bubbles: true })); input.focus(); });
  });

  /* loader: a candle and three paws on the first page of a visit (or every page, or never: theme setting). It lifts once the fonts
     are in and the paws have walked once; a slow network never keeps it up longer than four seconds. */
  const loader = $('[data-loader]');
  if (loader) {
    try { sessionStorage.setItem('em-seen', '1'); } catch (e) {}
    const t0 = performance.now(), min = reduced ? 0 : 1500;
    let done = false;
    const hide = () => { if (done) return; done = true; loader.classList.add('is-done'); setTimeout(() => loader.remove(), 700); };
    const ready = () => setTimeout(hide, Math.max(0, min - (performance.now() - t0)));
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(ready, ready);
    setTimeout(hide, 4000);
  }

  /* voices: one at a time beside the map, which lights the current city; dots and candles move it, it advances alone unless motion is reduced */
  if (reduced) $$('video[autoplay]').forEach(vid => { vid.removeAttribute('autoplay'); vid.pause(); });
  $$('[data-voices]').forEach(v => {
    const cards = $$('.voicecard', v), dots = $$('[data-voices-go]', v), candles = $$('.map__candle', v);
    if (cards.length < 2) return;
    let i = Math.max(0, cards.findIndex(c => c.hasAttribute('aria-current'))), timer;
    const show = n => {
      i = (n + cards.length) % cards.length;
      cards.forEach((c, k) => { if (k === i) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current'); });
      candles.forEach(g => g.classList.toggle('is-on', g.dataset.city === cards[i].dataset.city));
      dots.forEach((d, k) => d.setAttribute('aria-pressed', String(k === i)));
    };
    const stop = () => clearInterval(timer);
    const start = () => { stop(); if (!reduced && !document.hidden) timer = setInterval(() => show(i + 1), 7000); };
    dots.forEach((d, k) => d.addEventListener('click', () => { show(k); start(); }));
    $$('[data-voices-prev]', v).forEach(b => b.addEventListener('click', () => { show(i - 1); start(); }));
    $$('[data-voices-next]', v).forEach(b => b.addEventListener('click', () => { show(i + 1); start(); }));
    v.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') { show(i - 1); start(); } else if (e.key === 'ArrowRight') { show(i + 1); start(); } });
    const list = $('.voices', v);
    if (list) { let x0 = null; list.addEventListener('pointerdown', e => { x0 = e.clientX; }, { passive: true }); list.addEventListener('pointerup', e => { if (x0 !== null && Math.abs(e.clientX - x0) > 40) { show(e.clientX < x0 ? i + 1 : i - 1); start(); } x0 = null; }, { passive: true }); }
    candles.forEach(g => g.addEventListener('click', () => { const k = cards.findIndex(c => c.dataset.city === g.dataset.city); if (k >= 0) { show(k); start(); } }));
    v.addEventListener('mouseenter', stop); v.addEventListener('mouseleave', start);
    v.addEventListener('focusin', stop); v.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    show(i); start();
  });

  /* hero collections: a snapping row, one card wide on desktop. It advances by itself (not with reduced motion), and a wheel,
     a finger or the dots move it; after a hand movement it waits a while before going on. The dots follow the scroll position. */
  $$('[data-colls]').forEach(box => {
    const row = $('.colls-rot', box), items = $$('.colls-rot__item', box), dots = $$('[data-colls-go]', box);
    if (!row || items.length < 2) return;
    const desk = matchMedia('(min-width: 900px)');
    let i = 0, timer, idle, st;
    const left = k => items[k].offsetLeft - items[0].offsetLeft;
    const mark = n => { i = n; items.forEach((el, k) => { if (k === i) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current'); }); dots.forEach((d, k) => d.setAttribute('aria-pressed', String(k === i))); };
    const go = n => { n = (n + items.length) % items.length; mark(n); row.scrollTo({ left: left(n), behavior: reduced ? 'auto' : 'smooth' }); };
    const every = Math.max(3, Number(box.dataset.every) || 8) * 1000;
    const stop = () => clearInterval(timer);
    const start = () => { stop(); if (desk.matches && !reduced && !document.hidden) timer = setInterval(() => go(i + 1), every); };
    const pause = () => { stop(); clearTimeout(idle); idle = setTimeout(start, 8000); };
    row.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => { const x = row.scrollLeft; let best = 0, bd = Infinity; items.forEach((el, k) => { const d = Math.abs(left(k) - x); if (d < bd) { bd = d; best = k; } }); if (best !== i) mark(best); }, 80); }, { passive: true });
    ['wheel', 'pointerdown', 'touchstart'].forEach(t => row.addEventListener(t, pause, { passive: true }));
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); start(); }));
    box.addEventListener('mouseenter', stop); box.addEventListener('mouseleave', start);
    box.addEventListener('focusin', stop); box.addEventListener('focusout', start);
    desk.addEventListener('change', start);
    document.addEventListener('visibilitychange', start);
    mark(0); start();
  });


  /* "Come nascono": the painting video starts a little in (setting "Il video parte da") and every loop comes back there, not to 0.
     The mp4 also asks for #t= so it opens there before this runs; without JavaScript it loops from the start. */
  $$('[data-video-start]').forEach(box => {
    const v = $('video', box), t = parseFloat(box.dataset.videoStart) || 0;
    if (!v || !t) return;
    v.loop = false;
    v.addEventListener('ended', () => { v.currentTime = t; v.play()?.catch(() => {}); });
    const jump = () => { if (v.currentTime < t) v.currentTime = t; };
    if (v.readyState >= 1) jump(); else v.addEventListener('loadedmetadata', jump, { once: true });
  });

  /* toast + header count */
  const toast = html => { const t = $('[data-toast]'); if (!t) return; t.innerHTML = html; t.hidden = false; clearTimeout(t._t); t._t = setTimeout(() => { t.hidden = true; }, 5000); };
  const refreshCount = async () => {
    try {
      const c = await (await fetch(`${EM.cart}.js`, { headers: { Accept: 'application/json' } })).json();
      $$('[data-cart-count]').forEach(el => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
    } catch { /* count stays as rendered */ }
  };
  // shared with other scripts (candle builder)
  EM.toast = toast;
  EM.refreshCount = refreshCount;
  window.EM = EM;

  /* product form */
  const pf = $('[data-product-form]');
  if (pf) {
    let variants = [];
    try { variants = JSON.parse($('[data-variants]', pf)?.textContent || '[]'); } catch { variants = []; }
    const idInput = $('input[name=id]', pf), priceEl = $('[data-price]'), submit = $('button[type=submit]', pf), box = $('[data-custom-box]', pf);
    const selected = () => { const vals = []; $$('[data-opt]', pf).forEach(i => { if (i.type !== 'radio' || i.checked) vals[Number(i.dataset.index)] = i.value; }); return vals; };
    const current = () => { const s = selected(); return variants.find(v => v.options.every((o, i) => o === s[i])) || null; };
    const update = () => {
      const v = current();
      if (v) { idInput.value = v.id; if (priceEl) priceEl.textContent = v.price; submit.disabled = !v.available; submit.textContent = v.available ? submit.dataset.add : submit.dataset.soldOut; }
      else { submit.disabled = true; submit.textContent = submit.dataset.soldOut; }
      const mode = $('[data-custom]:checked, input[type=hidden][data-custom]', pf);
      if (box && mode) box.hidden = mode.dataset.custom !== 'true';
    };
    pf.addEventListener('change', update);
    update();
    $$('[data-qty]', pf).forEach(b => b.addEventListener('click', () => { const i = $('input[name=quantity]', pf); i.value = Math.max(1, Number(i.value) + Number(b.dataset.qty)); }));
    pf.addEventListener('submit', async e => {
      e.preventDefault();
      const fd = new FormData(pf);
      for (const [k, v] of [...fd.entries()]) { if (k.startsWith('properties[') && (v === '' || (v instanceof File && v.size === 0))) fd.delete(k); }
      submit.disabled = true;
      try {
        const r = await fetch(`${EM.add}.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || EM.t.error);
        toast(`${esc(EM.t.added)}: <strong>${esc(data.product_title)}</strong><a href="${EM.cart}">${esc(EM.t.go)}</a>`);       
await window.EM.syncMysteryBag?.();
refreshCount();
      } catch (err) { toast(esc(err.message || EM.t.error)); }
      finally { submit.disabled = false; update(); }
    });
  }

  /* cart page */
  const cart = $('[data-cart]');
  if (cart) {
    const change = async (line, quantity) => {
      try { await fetch(`${EM.change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) }); } catch { /* reload shows the truth either way */ }
      location.reload();
    };
    cart.addEventListener('click', e => {
      const b = e.target.closest('[data-line]'); if (!b) return;
      e.preventDefault();
      const input = $(`[data-line-input="${b.dataset.line}"]`, cart);
      change(Number(b.dataset.line), Math.max(0, Number(input?.value || 1) + Number(b.dataset.d)));
    });
    cart.addEventListener('change', e => { if (e.target.dataset.lineInput != null) change(Number(e.target.dataset.lineInput), Math.max(0, Number(e.target.value) || 0)); });
    const note = $('[data-cart-note]', cart); let nt;
    if (note) note.addEventListener('input', () => { clearTimeout(nt); nt = setTimeout(() => fetch(`${EM.update}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(() => {}), 500); });
  }

  /* scent burst: a pill with data-burst (its emoji, or image URLs from Content > Files) throws a dozen of them from the click;
     a keyboard pick bursts from the pill's centre. Nothing under reduced motion. */
  const burst = (tokens, x, y) => {
    if (reduced || !tokens.length) return;
    const n = 12;
    for (let k = 0; k < n; k++) {
      const t = tokens[Math.floor(Math.random() * tokens.length)];
      const el = document.createElement('span'); el.className = 'burst'; el.setAttribute('aria-hidden', 'true');
      if (/^(https?:)?\//.test(t)) { const im = document.createElement('img'); im.src = t; im.alt = ''; el.appendChild(im); } else el.textContent = t;
      const a = (-Math.PI / 2) + (Math.random() - .5) * Math.PI * 1.4, d = 70 + Math.random() * 110, dx = Math.cos(a) * d, dy = Math.sin(a) * d, r = (Math.random() - .5) * 240, s = .8 + Math.random() * .6;
      el.style.left = x + 'px'; el.style.top = y + 'px';
      document.body.appendChild(el);
      el.animate([
        { transform: 'translate(-50%, -50%) scale(.3) rotate(0deg)', opacity: 1 },
        { transform: `translate(calc(-50% + ${dx * .75}px), calc(-50% + ${dy * .75 - 20}px)) scale(${s * 1.15}) rotate(${r * .6}deg)`, opacity: 1, offset: .55 },
        { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy + 60}px)) scale(${s * .8}) rotate(${r}deg)`, opacity: 0 }
      ], { duration: 900 + Math.random() * 500, delay: Math.random() * 90, easing: 'cubic-bezier(.2, .7, .3, 1)', fill: 'forwards' }).onfinish = () => el.remove();
    }
  };
  $$('[data-burst-auto]').forEach(el => {
    const r = el.getBoundingClientRect(), tokens = el.dataset.burstAuto.split(' ').filter(Boolean);
    setTimeout(() => { burst(tokens, r.left + r.width / 2, r.top + 40); setTimeout(() => burst(tokens, r.left + r.width / 2, r.top + 40), 380); }, 350);
  });
  let lastPointer = 0;
  document.addEventListener('pointerdown', e => { const pill = e.target.closest('[data-burst]'); if (!pill) return; lastPointer = Date.now(); burst(pill.dataset.burst.split(' ').filter(Boolean), e.clientX, e.clientY); });
  document.addEventListener('change', e => { const pill = e.target.closest('[data-burst]'); if (!pill || Date.now() - lastPointer < 500) return; const r = pill.getBoundingClientRect(); burst(pill.dataset.burst.split(' ').filter(Boolean), r.left + r.width / 2, r.top + r.height / 2); });
})();
